import { writable } from 'svelte/store'
import { config } from '../config.js'
import { get, post, del } from '../services/http.js'
import { auth } from '../services/auth.js'

const initialState = {
  products: [],
  user_id: '',
  errorMsg: null,
}
function createFavorite() {
  const load = async () => {
    let user = await auth.getAuthenticatedUser();

    if(user){
      await get(`${config.apiUrl}/favorites`)
        .then(data => {
          if(data.error){
            set(initialState);
          }else{
            data.errorMsg = null;
            set(data);
          }
        });

    }else{
      set(initialState);
    }
  }
  const { subscribe, set, update } = writable(load() || initialState)

  return {
    subscribe,
    clearError: () => {
      update((favorites) => {
        favorites.errorMsg = null
        return favorites
      })
    },
    toggle: async (p) => {
      let userID = auth.getAuthenticatedUser()
      if (!userID) {
        let referrer = window.location.pathname;
        let errorMsg =
          "You must be signed in to save to your favorites. Login <a href='/login?referrer=" + referrer + "'>here</a>."
        update((favorites) => {
          favorites.errorMsg = errorMsg
          return favorites
        })
        return
      }

      update((favorites) => {
        let body = JSON.stringify({
          product_id: p.id,
        })

        if (favorites.products.some((x) => x.id === p.id)) {
          // remove from favorites
          del(`${config.apiUrl}/favorites`, body, 'application/json', false)
          let products = favorites.products.filter((x) => x.id !== p.id)
          favorites.products = products
          favorites.errorMsg = null
          return favorites
        } else {
          // add to favorites
          post(`${config.apiUrl}/favorites`, body, 'application/json', false)
          return { products: [...favorites.products, p], errorMsg: null }
        }
      })
    },
  }
}

export let favorite = createFavorite()
